module.exports = __webpack_public_path__ + "img/calendar.228936f7.svg";